import axios from 'axios'
import localforage from 'localforage'

const RESOURCE_NAME = '/clients'
var CLIENTS = localforage.getItem('clients')

export default {
  // async updateConstClients () {
  //   CLIENTS = null
  //   CLIENTS = localforage.getItem('clients')
  //   await CLIENTS.then((response) => {
  //     console.log(response, 'asdsda')
  //   })
  // },
  reinitiateResource () {
    CLIENTS = localforage.getItem('clients')
  },
  getAll (params) {
    let apiParams = new URLSearchParams(window.location.search).toString()
    if (params) {
      apiParams = Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&')
    }
    if (apiParams) {
      return axios.get(`${RESOURCE_NAME}?${apiParams.toString()}`)
    } else {
      return axios.get(`${RESOURCE_NAME}`)
    }
  },

  getAllSync () {
    return axios.get(`${RESOURCE_NAME}?per_page=-1`)
  },

  get (id) {
    if (navigator.onLine) {
      return axios.get(`${RESOURCE_NAME}/${id}`)
    } else {
      return this.getOfflineDataById(id)
    }
  },

  create (data) {
    return axios.post(RESOURCE_NAME, data)
  },

  update (id, data) {
    return axios.post(`${RESOURCE_NAME}/${id}`, data)
  },

  delete (id) {
    return axios.delete(`${RESOURCE_NAME}/${id}`)
  },

  addLocation (id, data) {
    return axios.post(`${RESOURCE_NAME}/${id}/locations`, data)
  },

  addContact (id, data) {
    return axios.post(`${RESOURCE_NAME}/${id}/contacts`, data)
  },

  transformInContact (id) {
    return axios.post(`${RESOURCE_NAME}/${id}/transform-in-contact`)
  },

  getOfflineData (params) {
    let urlParams = new URLSearchParams(params)
    // let urlParams = new URLSearchParams(window.location.search)
    return new Promise((resolve, reject) => { // The Promise used for router redirect in login
      let clients = {
        data: {
          data: [],
          meta: {}
        }
      }
      // clients.data.data = localforage.getItem('clients')
      CLIENTS.then((response) => {
        response.sort((a, b) => a.id >= b.id ? -1 : 1)
        let perPage = urlParams.get('per_page') ? urlParams.get('per_page') : 25
        let page = urlParams.get('page') ? urlParams.get('page') : 1
        page = page - 1
        let start = page * perPage
        let stop = parseInt(start, 10) + parseInt(perPage, 10)
        // SEARCH
        if (urlParams.get('q')) {
          let search = urlParams.get('q').toLowerCase().trim()
          let words = search.split(' ')
          for (let i = 0; i < words.length; i++) {
            response = response.filter(function (data) {
            // return data
              if (data.first_name && data.first_name.toLowerCase().includes(words[i])) {
                return data
              }
              if (data.last_name && data.last_name.toLowerCase().includes(words[i])) {
                return data
              }
              if (data.phone && data.phone.toLowerCase().includes(words[i])) {
                return data
              }
              if (data.company_name && data.company_name.toLowerCase().includes(words[i])) {
                return data
              }
              if (data.county && data.county.name.toLowerCase().includes(words[i])) {
                return data
              }
              if (data.city && data.city.name.toLowerCase().includes(words[i])) {
                return data
              }
            })
          }
        }
        // FILTER
        let city = urlParams.get('f_city') ? urlParams.get('f_city') : 0
        let county = urlParams.get('f_county') ? urlParams.get('f_county') : 0
        city = parseInt(city, 10)
        county = parseInt(county, 10)
        if (city > 0 || county > 0) {
          response = response.filter(function (data) {
            if (county > 0 && data.county && data.county.id === county) {
              if (city === 0) {
                return data
              }
              if (city > 0 && data.city && data.city.id === city) {
                return data
              }
            }
          })
        }
        // SORT
        // let sortBy = urlParams.get('sort_by') ? urlParams.get('sort_by') : null
        // let sortType = urlParams.get('sort_type') ? urlParams.get('sort_type') : 1
        // sortType = sortType === 'ASC' ? 1 : -1
        // if (sortBy) {
        //   if (sortBy === 'city' || sortBy === 'county') {
        //     // response.sort((a, b) => (a.sortBy > b.sortBy) ? 1 * sortType : (-1) * sortType)
        //     response.sort(function (a, b) {
        //       let sortA = a.sortBy != null ? a.sortBy.name : null
        //       let sortB = b.sortBy != null ? b.sortBy.name : null
        //       return (sortA < sortB) ? 1 * sortType : (-1) * sortType
        //     })
        //   } else {
        //     response.sort((a, b) => (a.sortBy > b.sortBy) ? 1 * sortType : (-1) * sortType)
        //   }
        // }
        // end SORT
        let total = response.length
        clients.data.data = response.slice(start, stop)
        if (total < perPage) {
          stop = total
        }
        clients.data.meta = {
          current_page: page + 1,
          from: start + 1,
          last_page: Math.ceil(total / perPage),
          per_page: perPage,
          to: stop,
          total: total
        }
        resolve(clients)
      })
    })
  },

  getOfflineDataById (id) {
    return new Promise((resolve, reject) => { // The Promise used for router redirect in login
      let client = {
        data: {
          data: null
        }
      }
      // clients.data.data = localforage.getItem('clients')
      localforage.getItem('clients').then((response) => {
        client.data.data = response.find(x => x.id === id)
        resolve(client)
      })
    })
  },
  getClientById (id) {
    return new Promise((resolve, reject) => { // The Promise used for router redirect in login
      let client = null
      // clients.data.data = localforage.getItem('clients')
      CLIENTS.then((response) => {
        client = response.find(x => x.id === id)
        if (!client) {
          axios.get(`${RESOURCE_NAME}/${id}`).then((response) => {
            let newClient = response.data.data
            localforage.getItem('clients').then((clients) => {
              clients.push(newClient)
              localforage.removeItem('clients')
              localforage.setItem('clients', clients)
            })
            resolve(newClient)
          })
            .catch((error) => {
              console.log(error)
              reject(error)
            })
        } else {
          resolve(client)
        }
      })
    })
  },

  getVtps (id) {
    return axios.get(`${RESOURCE_NAME}/get-vtps/${id}`)
  },

  importClients (data) {
    return axios.post(`import/clients`, data)
  },

  getTypes () {
    return axios.get(`${RESOURCE_NAME}/get-types/client`)
  },

  async getFromLocalStorage (params) {
    let urlParams = new URLSearchParams(params)
    let clients = []
    // let response = PRODUCTS
    await CLIENTS.then((response) => {
      // SEARCH
      if (urlParams.get('q')) {
        let search = urlParams.get('q').toLowerCase()
        search = search.trim().replace(/\s+/g, ' ')
        let keys = search.split(' ')
        let keywords = []

        for (let i in keys) {
          if (keys[i] && keys[i] !== ' ') {
            keywords.push(keys[i].trim())
          }
        }

        let score = 1
        let ok = 0
        let fields = ['first_name', 'last_name', 'company_name']
        response = response.filter(function (data) {
          score = 0
          for (let field of fields) {
            ok = 1
            if (data[field]) {
              let dataSearchfield = data[field] ? data[field].toLowerCase() : null
              for (let i = 0; i < keywords.length; i++) {
                if (dataSearchfield && dataSearchfield.includes(keywords[i])) {
                  score += keywords.length - i + 1
                }
              }

              if (dataSearchfield && dataSearchfield.includes(search)) {
                score += keywords.length * 2
              }
            }
          }

          let cui = data['cui'] ? data['cui'].toLowerCase() : null
          if (cui && cui === search) {
            score += 10
          }

          let cnp = data['cnp'] ? data['cnp'].toLowerCase() : null
          if (cnp && cnp === search) {
            score += 10
          }

          let county = data['county'] ? data['county']['name'].toLowerCase() : null
          if (county) {
            for (let i = 0; i < keywords.length; i++) {
              if (county.includes(keywords[i])) {
                score += 1
                break
              }
            }
          }

          let city = data['city'] ? data['city']['name'].toLowerCase() : null
          if (city) {
            for (let i = 0; i < keywords.length; i++) {
              if (city.includes(keywords[i])) {
                score += 1
                break
              }
            }
          }

          if (score > 0) {
            data['score'] = score
            return data
          }
        })
      }
      response.sort((a, b) => (a.score > b.score) ? -1 : 1)
      clients = response
    })
    return clients.slice(0, urlParams.get('per_page'))
  }
}
